import { map } from '@libs/shared';
import React, { forwardRef, PropsWithChildren, useMemo } from 'react';
// eslint-disable-next-line
import { ReactSortable, ItemInterface, ReactSortableProps } from 'react-sortablejs';

// 定义一个带有泛型和 children 的封装组件
type SortableComponentProps<T> = PropsWithChildren<ReactSortableProps<T>>;

const SortableComponent = forwardRef(
    <T extends ItemInterface>(props: SortableComponentProps<T>, ref: React.Ref<any>) => {
        const { list, children, ...restProps } = props;

        // react-sortableis 6.1.4 版本会通过 Object.assign 修改 list item
        // 若 list 来自 Immer/Redux 等不可变数据会报 " Cannot add property <key>., object is not extensible"
        // 见 https://github.com/SortableJS/react-sortablejs/issues/237
        const extensibleList = useMemo(() => {
            return map(list, (item) => ({ ...item }));
        }, [list]);

        return (
            <ReactSortable
                ref={ref}
                list={extensibleList}
                setData={(dataTransfer) => {
                    /**
                     * FXD-36957：用来处理FireFox浏览器在拖拽时会默认在浏览器中打开新标签
                     * issue: https://github.com/SortableJS/Sortable/issues/985
                     */
                    dataTransfer.setData('Text', '');
                }}
                {...restProps}
            >
                {children}
            </ReactSortable>
        );
    }
) as <T extends ItemInterface>(
    props: SortableComponentProps<T> & { ref?: React.Ref<HTMLElement> }
) => React.ReactElement;

export default SortableComponent;
